import { defineStore } from "pinia"

type AppLayoutType = "default" | "compact"

export interface IAppConfig {
  layout: AppLayoutType
}

export const useAppConfigStore = defineStore("appConfig", {
  state: (): IAppConfig => ({
    layout: "default",
  }),
  getters: {
    isCompact: (state) => {
      return state.layout === "compact"
    },
  },
  actions: {
    setAppLayout(value: AppLayoutType) {
      this.layout = value
    },
  },
})

export type AppConfigStore = ReturnType<typeof useAppConfigStore>
